import { z } from 'zod';

export const AvailabilityPreferencesSchema = z.object({
  preferredWeeklyMaxHours: z.number().min(0).max(60),
});

export type AvailabilityPreferences = z.infer<
  typeof AvailabilityPreferencesSchema
>;
